/**
 * Labstep
 */

import EntityActionCreate from 'labstep-web/components/Entity/Action/Create';
import { useHasAccess } from 'labstep-web/components/Entity/Can/hooks';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { ProtocolValueActionUpdateAmountModal } from 'labstep-web/components/ProtocolValue/Action/UpdateAmount/Modal';
import { AmountUpdate } from 'labstep-web/models/amount-update.model';
import { isAmountUpdated } from 'labstep-web/services/amount-unit.service';
import type React from 'react';
import { updateAmountActionComponentProps } from './constants';
import { getHeaderAndMessage } from './Modal/utils';
import type { IProtocolValueActionUpdateAmountProps } from './types';

export const ProtocolValueActionUpdateAmount: React.FC<
  IProtocolValueActionUpdateAmountProps
> = ({ protocolValue }) => {
  const canEdit = useHasAccess(
    protocolValue.entityName,
    protocolValue.guid,
    Action.edit,
    'resource_item',
  );
  if (protocolValue.is_output) {
    return null;
  }
  if (isAmountUpdated(protocolValue)) {
    return null;
  }
  if (!(protocolValue.resourceItem && canEdit)) {
    return null;
  }
  if (getHeaderAndMessage(protocolValue).header) {
    return (
      <ProtocolValueActionUpdateAmountModal
        protocolValue={protocolValue}
      />
    );
  }

  return (
    <EntityActionCreate
      entityName={AmountUpdate.entityName}
      body={{
        protocol_value_id: protocolValue.guid,
      }}
      actionComponentProps={updateAmountActionComponentProps}
      skipPermissionCheck
    />
  );
};
